var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "../styled-components";
export var resetList = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  li {\n    list-style: none;\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  li {\n    list-style: none;\n  }\n"])));
var templateObject_1;
